var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartIcon = function SvgCartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M14.422 20.32a2.206 2.206 0 0 0 2.202-2.209c0-1.22-.986-2.209-2.202-2.209s-2.202.99-2.202 2.21.986 2.208 2.202 2.208m0-1.178a1.03 1.03 0 0 1 0-2.062 1.03 1.03 0 0 1 0 2.061zM8.844 20.32a2.206 2.206 0 0 0 2.202-2.209c0-1.22-.986-2.209-2.202-2.209s-2.202.99-2.202 2.21.986 2.208 2.202 2.208m0-1.178a1.03 1.03 0 0 1-1.027-1.03c0-.57.46-1.032 1.027-1.032a1.03 1.03 0 0 1 0 2.061zm-1.326-4.418h10.015L20 6.441h-9.831v1.38h7.989l-1.645 5.523H8.707L7.336 3.68H4v1.38h2.147z"
  })));
};
export default SvgCartIcon;